module.exports = __webpack_public_path__ + "c8adff6759156f8db84f9feacc60cc4b.jpg";